import firebaseChatSlice from './firebase/chatSlice';

import uploadFileSlice from './uploadFileSlice';
import bidRequestsSlice from './bidRequestsSlice';
import bidRequestSlice from './bidRequestSlice';
import bidSlice from './bidSlice';
import offeringsSlice from './offeringsSlice';
import mortgageSurveySlice from './mortgageSurveySlice';
import myBundleSlice from './myBundleSlice';
import appSlice from './appSlice';
import notificationSlice from './notificationSlice';
import loanOfficerDashboardSlice from './loanOfficerDashboardSlice';
import loanOfficerSettingsSlice from './loanOfficerSettingsSlice';
import statesSlice from './statesSlice';
import quizSlice from './quizSlice';
import chatsSlice from './chatsSlice';
import { loanOfficerSubscriptionInfoReducer } from './loanOfficer/subscriptionInfoSlice';
import { loanOfficerSubscriptionReducer } from './loanOfficer/subscriptionSlice';
import { loanOfficerCreditCardReducer } from './loanOfficer/creditCardSlice';
import { administratorsLoanOfficersReducer } from './administrators/loanOfficersSlice';
import { realEstateAgentLoanOfficersReducer } from './realEstateAgent/loanOfficersSlice';
import { realEstateAgentFavoriteLoanOfficersReducer } from './realEstateAgent/favoriteLoanOfficersSlice';
import { realEstateAgentInviteBuyerReducer } from './realEstateAgent/inviteBuyerSlice';
import authEmailConfirmationSlice from './auth/emailConfirmationSlice';
import administratorsLoanOfficerSlice from './administrators/loanOfficerSlice';
import authResetPasswordSlice from './auth/resetPasswordSlice';
import authUpdatePasswordSlice from './auth/updatePasswordSlice';
import publicRealEstateAgentsSlice from './public/realEstateAgentsSlice';
import buyerLoanOfficersBidRequestsSlice from './buyer/loanOfficers/bidRequestsSlice';
import { publicBuyerLoanOfficersReducer } from './public/buyer/loanOfficersSlice';
import loanOfficerRealEstateAgentsSlice from './loanOfficer/realEstateAgentsSlice';
import waitlistLoanOfficersSlice from './realEstateAgent/waitlistLoanOfficersSlice';
import buyerSlice from './buyerSlice';

export default {
  firebaseChatSlice,
  loanOfficerSubscriptionInfoReducer,
  loanOfficerCreditCardReducer,
  loanOfficerSubscriptionReducer,
  administratorsLoanOfficerSlice,
  administratorsLoanOfficersReducer,
  buyerLoanOfficersBidRequestsSlice,
  realEstateAgentLoanOfficersReducer,
  realEstateAgentFavoriteLoanOfficersReducer,
  realEstateAgentInviteBuyerReducer,
  authResetPasswordSlice,
  authUpdatePasswordSlice,
  authEmailConfirmationSlice,
  uploadFileSlice,
  bidRequestSlice,
  bidRequestsSlice,
  offeringsSlice,
  bidSlice,
  mortgageSurveySlice,
  myBundleSlice,
  appSlice,
  notificationSlice,
  loanOfficerDashboardSlice,
  loanOfficerSettingsSlice,
  statesSlice,
  quizSlice,
  chatsSlice,
  publicRealEstateAgentsSlice,
  publicBuyerLoanOfficersReducer,
  buyerSlice,
  loanOfficerRealEstateAgentsSlice,
  waitlistLoanOfficersSlice,
};



// WEBPACK FOOTER //
// ./src/reducers/slices/index.js